<script setup lang="ts">
  import AppConfiguration from '@/AppConfiguration.vue'
  import { RouterView } from 'vue-router'
  import AppColorConfiguration from '@/AppColorConfiguration.vue'
  import AppGlobalComponentSetup from '@/AppGlobalComponentSetup.vue'
  import LoadingScreen from '@/components/LoadingScreen.vue'
  import router from '@/router'
  import { onMounted } from 'vue'
  import { SplashScreen } from '@capacitor/splash-screen'
  import {
    BarBackgroundStyle,
    useNativeStyle,
  } from './composables/useNativeStyle'

  const { adaptNativeStyle } = useNativeStyle()

  onMounted(async () => {
    await SplashScreen.hide()
    await adaptNativeStyle({
      statusBar: BarBackgroundStyle.PRIMARY,
      navigationBar: BarBackgroundStyle.PRIMARY,
    })
  })

  void router.replace({
    name: 'loading',
  })
</script>

<template>
  <Suspense timeout="0">
    <app-configuration>
      <template #default>
        <app-color-configuration>
          <app-global-component-setup>
            <router-view
              animated="false"
              :appium-route-name="router.currentRoute.value.name"
              :appium-route-path="router.currentRoute.value.path"
              appium="router"
            >
            </router-view>
          </app-global-component-setup>
        </app-color-configuration>
      </template>
    </app-configuration>
    <template #fallback>
      <Transition name="fade">
        <loading-screen />
      </Transition>
    </template>
  </Suspense>
</template>
<style>
  :root {
    --primary: #1a9dd9;
    --primary-light: #1a9dd9;
  }
</style>
